import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const AiImageHistoryContainer = styled.div`
  padding: 18px 16px 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden overlay;
  ${customizeVerticalScrollbarThumbMixin()}
  gap: 16px;
`

export const AiImageTabContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`
